import { IOcojoImageSource } from "../../../domain/ocojo";
import { ImageSourceKinds } from "../../../domain/document/ImageSourceKinds";
import { ClaioImageSource } from "../../claio/ver2";

export class OcojoImageSource extends ClaioImageSource implements IOcojoImageSource {
  constructor(
    getToken: () => string,
    patientId: string,
    claioImageKey: string,
    imageGuid: string,
    imageSourceKind: ImageSourceKinds,
    isMovie: boolean,
    isLeft: boolean,
    isRight: boolean,
    isSecret: boolean,
    departmentId: string,
    isVisibleLayer: boolean,
    imageDate: Date,
    imageKind: string,
  ) {
    super(getToken, patientId, claioImageKey, imageGuid, imageSourceKind, isMovie, isLeft, isRight, isSecret, departmentId, isVisibleLayer, imageDate, imageKind);
  }

  public get thumbnailSource(): string {
    if (!this.claioImageKey) { return null; }
    const url = "/api/patient/" + this.patientId + "/ocojo/thumbnail/" + this.claioImageKey + "?token=" + this.token + "&isVisibleLayer=" + !!this.isVisibleLayer;
    console.debug("[ocojo thumbnail image source] " + url);
    return url;
  }

  public get originalSource(): string {
    if (!this.claioImageKey) { return null; }
    const url = "/api/patient/" + this.patientId + "/ocojo/image/" + this.claioImageKey + "?token=" + this.token + "&isVisibleLayer=" + !!this.isVisibleLayer;
    console.debug("[ocojo original image source] " + url);
    return url;
  }

  public clone(): IOcojoImageSource {
    return new OcojoImageSource(
      this._getToken,
      this.patientId,
      this.claioImageKey,
      this.imageGuid,
      this._imageSourceKind,
      this.isMovie,
      this.isLeft,
      this.isRight,
      this.isSecret,
      this.departmentId,
      this.isVisibleLayer,
      this.imageDate,
      this.imageKind,
    );
  }
}
